import Vue from 'vue';
import VueRouter from 'vue-router';
import regRouterEach from '@/router/routerEach.js';

import walkthrough from './modules/walkthrough.js'; // 攻略模块
import tools from './modules/tools.js'; // 工具模块
import welfare from './modules/welfare.js'; // 福利模块
import mine from './modules/mine.js'; // 我的模块
import square from './modules/square.js'; // 广场
import activity from './modules/activity.js';
import guest from './modules/guest.js';
import common from './modules/common.js';

Vue.use(VueRouter);


const routes = [].concat(walkthrough, tools, welfare, square, mine, common, activity, guest);

// 修改路由重复点击报错。
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => {
    console.log(err);
  });
};
// replace
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.replace = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch((err) => {
    console.log(err);
  });
};

const router = new VueRouter({
  mode: 'history',
  routes,
});

regRouterEach(router);
// const { mosso } = registerRouter(router);

// Vue.prototype.$mosso = mosso;

export default router;
